import React from "react";
import PhoneHeader from "../../Components/Common/PhoneHeader";
import { ReactComponent as Calendar } from "../../assets/icons/Calendar.svg";
const moment = require("moment-jalaali");
function MessagesSingle({ location }) {
  const data = location?.state;

  return (
    <div className="Container" id="Container">
      <div
        className="mobileContainer"
        style={{
          paddingTop: window.innerHeight * 0.15,
          overflowY: "scroll",
        }}
      >
        <PhoneHeader text={"جزییات پیام"} />

        <div style={{ width: "95%" }}>
          <div className="StartDiv">
            <span>{data?.title}</span>
          </div>
          <div className="divider" />
          <div className="StartDiv">
            <div className="StartDiv">
              <Calendar />
              <span
                className="dateSpan"
                style={{ marginRight: 5, color: "#797979" }}
              >
                {moment(data?.created_at).format("jYYYY/jMM/jDD")}
              </span>
            </div>
          </div>
          <div className="divider" />
          <div className="StartDiv">
            <span
              className="dateSpan"
              style={{ marginRight: 5, color: "#797979", fontSize: "15px" }}
            >
              لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با
              استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله
              در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد
              نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد،
              کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان
              جامعه و متخصصان را می طلبد
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MessagesSingle;
